export default __webpack_public_path__ + "static/media/SmartBeans_logo_bw.2ae19ed0.svg";